module.exports = __webpack_public_path__ + "img/picture-frame.25957cb8.svg";